import { useEffect, type ReactNode } from 'react';
import { Link } from 'wouter';
import { Header, MobileBar, SiteFooter } from '@/components/site-layout';

type LegalPageLayoutProps = {
  title: string;
  description: string;
  children: ReactNode;
};

export function LegalPageLayout({
  title,
  description,
  children,
}: LegalPageLayoutProps) {
  useEffect(() => {
    const previousTitle = document.title;
    const descriptionElement = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );
    const previousDescription = descriptionElement?.content;

    document.title = `${title} · SHER CLEAN`;
    if (descriptionElement) descriptionElement.content = description;

    return () => {
      document.title = previousTitle;
      if (descriptionElement && previousDescription !== undefined) {
        descriptionElement.content = previousDescription;
      }
    };
  }, [description, title]);

  return (
    <div className="site-shell noise">
      <Header />
      <main className="legal-page">
        <div className="container-wide legal-page-container">
          <Link href="/" className="legal-return" data-testid="legal-home-link">
            ← Retour à l’accueil
          </Link>
          <article className="legal-article">
            <span className="eyebrow">SHER SOLUTIONS · SHER CLEAN</span>
            <h1>{title}</h1>
            <p className="legal-intro">{description}</p>
            <div className="legal-body">{children}</div>
          </article>
        </div>
      </main>
      <SiteFooter />
      <MobileBar />
    </div>
  );
}
